import React from 'react';

const InvalidTokenError = () => (
  <>
    <div className="reset-password-wrapper reset-error">
      <div className="form-container">
        <span className="icon icon-error" />
        <h2>Link expired</h2>
        <p>
          The link you were looking for has either already been used or has expired.
        </p>
      </div>
    </div>
  </>
);
export default InvalidTokenError;
